import Vue from 'vue';

import Router from 'vue-router'

Vue.use(Router);

import storage from './common/storage'

var router = new Router({
    //mode: 'hash',
    //base: process.env.VUE_APP_API_URL,
    routes: [{
            path: '/',
            name: 'login',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                title: '登录',
            },
            component: () =>
                import('./components/login/login.vue')
        }, {
            path: '/',
            name: 'main',
            redirect: '/userManage',
            component: () =>
                import('./components/main/main.vue'),
            children: [{
                    path: '/userManage',
                    name: 'userManage',
                    meta: {
                        title: '单位管理',
                    },
                    component: () =>
                        import('./components/userManage/list.vue')
                },
                {
                    path: '/unitManage',
                    name: 'unitManage',
                    meta: {
                        title: '用户管理',
                    },
                    component: () =>
                        import('./components/unitManage/list.vue')
                },
                {
                    path: '/deviceManage',
                    name: 'deviceManage',
                    meta: {
                        title: '设备管理',
                    },
                    component: () =>
                        import('./components/deviceManage/list.vue')
                },
                {
                    path: '/settingManage',
                    name: 'settingManage',
                    meta: {
                        title: '配置项管理',
                    },
                    component: () =>
                        import('./components/settingManage/list.vue')
                },
                {
                    path: '/deviceManage/deviceAppAuthManage',
                    name: 'deviceAppAuthManage',
                    meta: {
                        title: '设备应用授权',
                    },
                    component: () =>
                        import('./components/deviceManage/deviceAppAuthManage/list.vue')
                },
                {
                    path: '/translateManage',
                    name: 'translateManage',
                    meta: {
                        title: '翻译管理',
                    },
                    component: () =>
                        import('./components/translateManage/list.vue')
                },
                {
                    path: '/authorizeManage',
                    name: 'authorizeManage',
                    meta: {
                        title: '授权管理',
                    },
                    component: () =>
                        import('./components/authorizeManage/list.vue')
                },
                {
                    path: '/operationList',
                    name: 'operationList',
                    meta: {
                        title: '接口日志',
                    },
                    component: () =>
                        import('./components/LogManage/operationList.vue')
                },
                {
                    path: '/errorList',
                    name: 'errorList',
                    meta: {
                        title: '错误日志',
                    },
                    component: () =>
                        import('./components/LogManage/errorList.vue')
                },
                // {
                //     path: '/appTypeManage',
                //     name: 'appTypeManage',
                //     meta: {
                //         title: '应用类型管理',
                //     },
                //     component: () =>
                //         import ('./components/appTypeManage/list.vue')
                // },
                {
                    path: '/appManage',
                    name: 'appManage',
                    meta: {
                        title: '应用管理',
                    },
                    component: () =>
                        import('./components/appManage/list.vue')
                },
                {
                    path: '/appManage/versionManage',
                    name: 'versionManage',
                    meta: {
                        title: '应用版本',
                    },
                    component: () =>
                        import('./components/appManage/versionManage/list.vue')
                },
                {
                    path: '/dingdingManage',
                    name: 'dingdingManage',
                    meta: {
                        title: '应用版本',
                    },
                    component: () =>
                        import('./components/dingdingManage/list.vue')
                },
                {
                    path: '/tagManage',
                    name: 'tagManage',
                    meta: {
                        title: '标签管理',
                    },
                    component: () =>
                        import('./components/tagManage/list.vue')
                },
                {
                    path: '/tagManage/detail',
                    name: 'tagManage/detail',
                    meta: {
                        title: '标签详情',
                    },
                    component: () =>
                        import('./components/tagManage/detail/list.vue')
                }
            ]
        },
    ]
})


router.beforeEach((to, from, next) => {
    let token = storage.getSession('token');
    if (!token) {
        if (to.path === '/login') {
            next()
        } else {
            next({
                path: '/login'
            })
        }
    } else {
        next()
    }
})


export default router;